import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

const getDraftData = (selectedCargo, reportType) => {
  if (reportType === "before") {
    const remarks = selectedCargo?.activities?.["first-line-ashore"]?.remarks;
    return {
      forward: remarks?.forward || "",
      aft: remarks?.aft || "",
    };
  }

  const remarks = selectedCargo?.activities?.["pilot-disembarked"]?.remarks;
  return {
    forward: remarks?.forward || "",
    aft: remarks?.aft || "",
  };
};

export const createSlopPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  reportType,
  companyLogo,
  date,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo || !selectedTrip) {
    throw new Error("Please select a cargo before printing.");
  }

  const slopEntry =
    reportType === "before"
      ? selectedCargo?.slopData?.before
      : selectedCargo?.slopData?.after;

  const measurements = slopEntry?.measurements || {};
  const draft = getDraftData(selectedCargo, reportType);
  const calculatedTrim =
    draft.forward !== "" && draft.aft !== ""
      ? Number(draft.forward) - Number(draft.aft)
      : "";
  const trim = Number.isFinite(calculatedTrim)
    ? Number(calculatedTrim.toFixed(3))
    : "";

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: "SlopTank(s) Report/Certificate",
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    date: date || "\u2014",
    portName: selectedTrip?.from || "\u2014",
    berthName: selectedTrip?.jetty || "N/A",
    condition: reportType === "before" ? t("before") : t("after"),
    draft,
    trim,
    measurements,
    remarks: slopEntry?.remarks || "",
  };
};
